import { Invoice, InvoiceStatus } from '@/models';
import { DEFAULT_I18N } from '@/plugins/i18n';

export function downloadBlob(blob: Blob | File, filename?: string): void {
  const a = document.createElement('a');
  a.download = filename || (blob as File).name || 'download';
  a.rel = 'noopener';
  a.href = URL.createObjectURL(blob);
  setTimeout(() => URL.revokeObjectURL(a.href), 4e4);
  setTimeout(() => {
    try {
      a.dispatchEvent(new MouseEvent('click'));
    } catch (e) {
      const evt = document.createEvent('MouseEvents');
      evt.initMouseEvent(
        'click',
        true,
        true,
        window,
        0,
        0,
        0,
        80,
        20,
        false,
        false,
        false,
        false,
        0,
        null,
      );
      a.dispatchEvent(evt);
    }
  }, 0);
}

/**
 * Generates a filename for an invoice in forms like 'invoice-201800001.pdf', 'draft-29128.pdf'
 * @param invoice
 * @param suffix
 * @param reminder
 */
export function generateInvoiceFileName(
  invoice: Invoice,
  suffix: string = '.pdf',
  reminder: boolean = false,
): string {
  let prefixKey: string;
  switch (invoice.status) {
    case InvoiceStatus.DRAFT:
      prefixKey = 'invoice.types.draft';
      break;

    case InvoiceStatus.QUOTATION:
    case InvoiceStatus.DRAFT_QUOTATION:
    case InvoiceStatus.ARCHIVED_QUOTATION:
      prefixKey = 'invoice.types.quotation';
      break;

    default:
      prefixKey = 'invoice.paymentTypes.standard';
      break;
  }

  if (reminder) {
    prefixKey = 'invoice.types.reminder';
  }

  let prefix: string = DEFAULT_I18N.tc(prefixKey).toLowerCase();

  // Check if i18n went wrong, if so just take the part after the last dot
  if (prefix.includes('.')) {
    prefix = prefix.substring(prefix.lastIndexOf('.') + 1);
  }

  // Use number, otherwise id when number is not available
  const identifier = invoice.number || invoice.id;

  return `${prefix}-${identifier}${suffix}`;
}
